import $ from 'jquery';
jQuery.noConflict();

export function homepageFunctions() {
    (function updateDealOfTheDay() {
        var link = jQuery('a.dotd-link').attr('href');
        var dt = new Date();
        var dt = dt.getTime();
        link = link + '?cachebuster=' + dt;
        jQuery('a.dotd-link').attr('href', link);
    })();

    jQuery('.loading-spinner').hide();
    jQuery('.section-reviews').show();
    var $product = jQuery('.section-reviews .reviews-container');
    $product.each(function (i) {
        var rating = jQuery(this).data('summary');
        var ratingDiv = jQuery(this).find('.reviews-product-rating .tt-teaser');

        function getStars(rating) {
            // Round to nearest half
            rating = Math.round(rating * 2) / 2;
            let output = [];

            // Append all the filled whole stars
            for (var i = rating; i >= 1; i--) {
                output.push(
                    '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span>'
                );
            }

            // If there is a half a star, append it
            if (i == .5) {
                output.push(
                    '<span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span>'
                );
            }

            // Fill the empty stars
            for (var i = (5 - rating); i >= 1; i--) {
                output.push(
                    '<span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
                );
            }

            return output.join('');
        }

        ratingDiv.html(getStars(rating));
    });

    var $reviews = jQuery('.section-reviews .section-reviews-products');
    $reviews.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        rows: 0,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 5000,
        prevArrow: '<div class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>',
        nextArrow: '<div class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>',
        lazyLoad: 'ondemand',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            }
        ]
    });


}